<template>
  <div>
    <div class="page-header clear-filter" filter-color="black3">
      <parallax
        v-bind:useScroll="false"
        class="page-header-image"
        style="background-image:url('/img/img_map.png')"
      ></parallax>
      <n-button
        type="primary"
        class="col-sm-6 col-lg-3"
        style="margin-top: 100px; width: 100%; text-align: center;"
        ref="header0"
        @click="toggle(0);"
      >
        {{$t('Select Zone')}} [{{currentZone}}]
        <div style="position: absolute; left: 220px; top: 12px;">
          <i
            v-if="!toggles[0]"
            class="now-ui-icons arrows-1_minimal-up"
            style="position: relative; left: 110px;"
          ></i>
          <i
            v-if="toggles[0]"
            class="now-ui-icons arrows-1_minimal-down"
            style="position: relative; left: 110px;"
          ></i>
        </div>
      </n-button>
      <div ref="content0" style="display: block;">
        <div
          class="minimap-area"
          v-bind:style="{width: `${minimapSize + 12}px`, height: `${minimapSize + 12}px`}"
        >
          <div class="minimap-scroll-stage">
            <grid-layer
              :viewport="viewport"
              :visible="showGridChecked"
              v-bind:onSale="true"
              v-if="renderGrid"
              v-bind:columnCount="8"
              v-bind:rowCount="8"
              v-bind:tileWidth="minimapTileSize"
              v-bind:tileHeight="minimapTileSize"
              v-bind:mapType="0"
            ></grid-layer>
          </div>
        </div>
      </div>
      <n-button
        type="info"
        class="col-sm-6 col-lg-3"
        style="text-align: center;"
        ref="header1"
        @click="toggle(1);"
      >
        {{$t('Select Land')}} [{{selectedLandId == 0 ? '-' : `#${selectedLandId}`}}]
        <div style="position: absolute; left: 220px; top: 12px;">
          <i
            v-if="!toggles[1]"
            class="now-ui-icons arrows-1_minimal-up"
            style="position: relative; left: 110px;"
          ></i>
          <i
            v-if="toggles[1]"
            class="now-ui-icons arrows-1_minimal-down"
            style="position: relative; left: 110px;"
          ></i>
        </div>
      </n-button>
      <div ref="content1" style="display: none;">
        <div
          style="background-image: url('/img/frame_zone_m.png'); background-size: 100% 100%; position: absolute; left: 0px; top: 206px; width: 100%; height: 412px;"
        ></div>
        <div
          ref="mapscroll"
          v-dragscroll
          style="overflow: auto; height: 400px; margin: 6px;"
          v-on:dragscrollmove="onScrollMove($event.detail)"
        >
          <div class="map-area">
            <!-- <div class="map-title">
              <h6 class="card-title mb-4">Zone #{{currentZone}}</h6>
            </div>-->
            <div class="map-scroll-stage">
              <grid-layer
                :viewport="viewport"
                :visible="showGridChecked"
                v-bind:visibleDevRank="visibleDevRank"
                v-bind:onSale="true"
                v-if="renderGrid"
                v-bind:mapType="1"
                v-bind:selectedId="selectedId"
                v-bind:minimapScroll="minimapScroll"
              ></grid-layer>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="cart-area">
      </div>-->
    </div>
  </div>
</template>
<script>
import { Parallax, Button } from "@/components";
import axios from "axios";
import config from "../config.js";
// import MapLayer from '../components/partials/MapLayer.vue';
import GridLayer from "../components/partials/GridLayer.vue";
import VueScreenSize from "vue-screen-size";
import { dragscroll } from "vue-dragscroll";

const HIDE_GRID_WHEN_SCROLLING = true;
export default {
  name: "Map",
  directives: {
    dragscroll: dragscroll
  },
  components: { GridLayer, Parallax, [Button.name]: Button },
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data: () => ({
    viewport: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
    landUrl: "",
    isScrolling: false,
    scrollingTimer: null,
    mousedownFlag: false,
    mousedownOffset: null,
    showGridChecked: true,
    visibleDevRank: "off",
    selectedLandId: 0,
    landInfo: {},
    objects: [],
    trees: [],
    minimapSize: 0,
    mapSize: 0,
    minimapTileSize: 0,
    mapTileSize: 0,
    toggles: [true, false],
    minimapScroll: [0, 0, 0, 0]
  }),
  computed: {
    currentLandId() {
      return this.$store.state.area.selectedLand;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    renderGrid() {
      return !HIDE_GRID_WHEN_SCROLLING || !this.isScrolling;
    },
    selectedId() {
      let landId = this.$route.params.landId;
      if (landId == null) {
        return 0;
      }
      return parseInt(landId);
    }
  },
  mounted() {
    let screenWidth = this.$vssWidth;
    let minimapSize = Math.floor(screenWidth) - 12;
    let minimapTileSize = Math.floor(minimapSize / 8);
    minimapSize = minimapTileSize * 8;
    this.minimapSize = minimapSize;
    this.minimapTileSize = minimapTileSize;

    console.log(this.minimapSize, this.minimapTileSize);

    let landId = this.$route.params.landId;
    if (landId != null) {
      this.changeLandId(landId);
    }

    this.$nextTick(() => {});
  },
  watch: {
    "$store.state.map.currentZone": function(val) {
      this.toggle(1);
    },
    // "$route.params.landId": function(landId) {
    //   this.changeLandId(landId);
    // },
    async currentLandId(val) {
      //   const treeCodes = [501, 502, 503, 504, 505, 601, 602, 603];
      //   this.trees = [];
      //   for (let i = 0; i < 10; ++i) {
      //     this.trees.push({
      //       _id: i,
      //       code: treeCodes[Math.floor(Math.random() * treeCodes.length)],
      //       x: Math.floor(Math.random() * 8) * 40,
      //       y: Math.floor(Math.random() * 8) * 40
      //     });
      //   }
      //   this.landUrl = `${config.web.url}/map/${val[0]}`;
      //   this.landInfo = await this.getLandInfo(val[0]);
      //   this.objects = await this.getFieldObjects(val[0]);
      this.selectedLandId = val[0];
    }
  },
  methods: {
    onScrollMove: function() {
      if (this.$refs.mapscroll == null) {
        this.minimapScroll = [0, 0, 0, 0];
      } else {
        this.minimapScroll = [
          (this.$refs.mapscroll.scrollLeft / 800) * 128,
          (this.$refs.mapscroll.scrollTop / 800) * 128,
          (this.$refs.mapscroll.clientWidth / 800) * 128,
          (this.$refs.mapscroll.clientHeight / 800) * 128
        ];
      }
    },
    toggle: function(content) {
      console.log("content - ", content);
      for (let i = 0; i < this.toggles.length; ++i) {
        if (i == content) {
          this.toggles[i] = true;
          this.$refs[`content${i}`].style = "display: block;";
        } else {
          this.toggles[i] = false;
          this.$refs[`content${i}`].style = "display: none;";
        }
      }
      this.onScrollMove();
    },
    changeLandId: async function(landId) {
      if (landId != null) {
        landId = parseInt(landId);
        if (landId >= 100000 && landId <= 165535) {
          this.landUrl = `${config.web.url}/map/${landId}`;

          let currentLandId = landId;
          landId = landId % 100000;
          let landX = landId % 256;
          let landY = 255 - Math.floor(landId / 256);
          landX = Math.floor(landX / 32);
          landY = Math.floor(landY / 32);
          let zoneIdx = landY * 8 + landX;

          let zoneId = this.$store.state.map.zoneMap[zoneIdx];
          this.$store.commit("clickWorldMap", {
            key: zoneId
          });
          this.$store.commit("setSelectedLandId", currentLandId);
        }
      }
    },
    goToLandPage: function() {
      //this.$router.push(`/land/${this.selectedLandId}`)
      window.open(`${config.web.url}/land/${this.selectedLandId}`, "_blank");
    },
    getEtherScanUrl: function(address) {
      return `${config.etherscan.account}/${address}`;
    },
    getHexColor: function(number) {
      return "#" + (number >>> 0).toString(16).slice(-6);
    },
    onMousedown(e) {
      this.mousedownFlag = true;
      this.mousedownOffset = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.isDragging = false;
    },
    onMousemove(e) {
      if (!this.mousedownFlag) {
        return;
      }
      if (this.isDragging) {
        this.adjustViewportPosition(
          -e.originalEvent.movementX,
          -e.originalEvent.movementY,
          1
        );
      } else if (
        Math.abs(this.mousedownOffset.x - e.offsetX) +
          Math.abs(this.mousedownOffset.y - e.offsetY) >
        2
      ) {
        this.isDragging = true;
      }
    },
    onMouseup() {
      this.mousedownFlag = false;
      this.isDragging = false;
    },
    onClickMap() {},
    onCopy: function() {
      alert(this.$t(`info_copied`));
    },
    onError: function() {}
  }
};
</script>

<style scoped>
.map-pos {
  position: absolute;
  right: 255px;
  top: 10px;
  font-size: 14px;
  color: #fff;
  user-select: none;
  text-align: right;
}
.map-title {
  color: #00ff00;
  width: 600px;
  height: 25px;
  text-align: left;
  padding: 10px 70px;
}
.map-title-devrank {
  position: absolute;
  top: 80px;
  left: 255px;
  width: 800px;
  height: 50px;
  text-align: right;
}
.map-area {
  width: 800px;
  height: 800px;
  margin: 0px auto;
}
.map-scroll-stage {
  width: 800px;
  height: 800px;
}
.minimap-area {
  width: 100vw;
  height: 100vw;
  overflow: none;
  margin: 0px auto;
  background-image: url("/img/frame_world.png");
  background-size: 100% 100%;
}
.minimap-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.minimap-scroll-stage {
  margin: auto;
  width: 100%;
  height: 100%;
  padding: 6px;
  overflow: none;
}
.cart-area {
  position: absolute;
  top: 480px;
  right: calc(50% + 436px);
  width: 322px;
  height: 442px;
  overflow: none;
  border: #000 solid 1px;
  padding: 10px;
}
.gamemap-area {
  position: absolute;
  top: 83px;
  left: calc(50% + 436px);
  width: 328px;
  height: 349px;
  background-image: url("/img/frame_field.png");
  overflow: none;
}
.gamemap-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.gamemap-scroll-area {
  position: absolute;
  top: 25px;
  left: 4px;
  width: 320px;
  height: 320px;
  background-image: url("/img/map/map_01.png");
  overflow: none;
}
.map-area.dragging {
  cursor: move;
}
.map-selector {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 150px;
  font-size: 12px;
  user-select: none;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 3px;
  color: #000;
  border: 1px solid #000;
}
.map-selector ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.urban-list {
}
.urban-list .urban-item {
  position: relative;
}
.urban-list .urban-item > span {
  display: block;
  padding: 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
}
.urban-list .urban-item:first-child > span {
  border-top: none;
}
.urban-list .urban-item::after {
  content: "+";
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 25px;
  color: #666;
}
.urban-list .urban-item.active::after {
  content: "-";
}
.map-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: #f0f0f0;
}
.map-list .map-item {
  display: none;
}
.map-list .map-item a {
  display: block;
  padding: 5px;
  border-top: 1px solid #ccc;
  font-size: 11px;
  color: #333;
  text-decoration: none;
  outline: none;
}
.map-list .map-item a:hover {
  background-color: #e5e5e5;
}
.map-list .map-item a::before {
  content: "-";
  display: inline-block;
  padding: 0 5px;
}
.map-list .map-item.active a {
  background-color: #e5e5e5;
}
.map-list .map-item.active a::before {
  content: ">>";
}
.urban-list .urban-item.active .map-item {
  display: block;
}
.map-list .map-item.active {
  display: block;
}
table,
th,
td {
  border: 0px solid white !important;
  min-width: 0px !important;
  min-height: 0px !important;
}
</style>